import { Button, ButtonSizeTypes, Table, TableColumn, TableMetaProps } from '@digicert/dcone-common-ui'
import React, { ReactElement, useCallback, useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import EditUserSideRail from '../EditUserSideRail'
import { UserUpdateType } from '../user-overview/UserOverview.types'
import styles from './UserServices.module.scss'
import { connect } from 'react-redux'
import { fetchServicesByUserId } from 'secure-pages/tenants/tenant/services/Services.actions'
import { IAccessScope, IServiceProviderAccount } from 'reducers/Reducers.interfaces'
import { translate } from 'shared/helpers/utils'
import { LIMIT_10 } from 'core/utils/constants'
import { DIGIROOT_ID } from 'core/constants'

const UserServices = ({ user, fetchServicesByUserId, profile }): ReactElement => {

    const defaultMeta: TableMetaProps<IServiceProviderAccount> = {
        pageSize: LIMIT_10,
        currentPage: 1,
        totalItems: 0,
        filters: {},
        sort: {
            columnKey: "source_account_name",
            order: "ascend"
        }
    }

    const [meta, ] = useState(defaultMeta)
    const [services, setServices] = useState<IServiceProviderAccount[]>()
    const [showSideRail, setShowSideRail] = React.useState(false)
    const [loading, setLoading] = useState(true) 


    const getTableColumns = (): TableColumn<IServiceProviderAccount>[] => [
        {
            key: 'name',
            title: translate('accounts.details.services.accountName') as string,
            sorter: true,
            render: serviceProviderAccount => (
                <>
                {serviceProviderAccount.name && !serviceProviderAccount.account_url && <p>{serviceProviderAccount.name}</p>}
                {serviceProviderAccount.show_account_required && <p>{translate('accounts.details.services.accountRequied')}</p>}
                {serviceProviderAccount.show_add_account_link && <a rel="noreferrer" href={serviceProviderAccount.account_url} target='_blank'>{translate('accounts.details.services.addAccount')}</a>}
                {serviceProviderAccount.account_url && serviceProviderAccount.name && <a rel="noreferrer" href={serviceProviderAccount.account_url} target='_blank'>{serviceProviderAccount.name}</a>}
                </>
                
            )
        },
        {
            key: 'id',
            title: translate('accounts.details.services.accountId') as string,
            sorter: true,
            render: serviceProviderAccount => (
                 <>{serviceProviderAccount.id ? serviceProviderAccount.id : '-' }</>
            )
        },
        {
            key: 'enabled_services',
            title: translate('accounts.details.services.enabledServices') as string,
            render: serviceProviderAccount => (
                <>
                    {serviceProviderAccount.enabled_services.map((item) => {
                        return (
                            <div key={item}>{item}</div>
                        )
                    })}
                </>
            )
        }
    ]
    
       const tableChange = useCallback(
        () => {
            console.log('Waiting on backend to sort')
        },
        []
    )

    useEffect(()=> {
        setLoading(false)
        fetchServicesByUserId(user.id).then(res => {
            setServices(res.service_provider_accounts)
        })
    },[])

    const canEditUser =  user?.status === 'ACTIVE' && (user?.access_scope === IAccessScope.system ?
        (user?.id === DIGIROOT_ID ? profile?.can_edit_root_user :  profile?.can_edit_system_user) : profile?.can_edit_account_user)


    return (
        <section className={styles.userServices}>
            <header className={styles.header}>
                <div>
                    <h1><Translate id='manageUser.administrators.userServices' /></h1>
                    <p><Translate id='manageUser.administrators.access'/></p>
                </div>
                {canEditUser && user?.id !== profile?.id &&
                    <Button size={ButtonSizeTypes.SMALL} onClick={() => setShowSideRail(true)}><Translate id='common.form.buttons.updateServices'/></Button>
                }
            </header>

            {services && services?.length > 0 && 

                <div className={styles.content}>
                    <Table
                        className={styles.table + ' ' +  'resizable-table-body'}
                        columns={getTableColumns()}
                        items={services}
                        getRowKey={account => account.id}
                        meta={meta}
                        onChange={tableChange}
                        disableCheckBoxes
                        loading={loading}
                    />
                </div>

            }

            <EditUserSideRail
                user={user}
                showSideRail={showSideRail}
                sideRailContent={UserUpdateType.UserServices}
                setShowSideRail={setShowSideRail} 
                setServices={setServices}
            />
        </section>
    )
}
export default connect(null, { fetchServicesByUserId })(UserServices);